const SDK_VERSION = "10.54.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
